import AppConfig from '~/infra/config';
import CustomHttpClient from '~/infra/http';

export interface StrapiResponse<T> {
  data: T | null;
  error: unknown;
}

export interface Pagination {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

export interface StrapiCollectionResponse<T> {
  data: T[];
  meta: {
    pagination: Pagination;
  };
}

const strapiClient = new CustomHttpClient({
  url: AppConfig.API_URL,
  revalidate: AppConfig.REVALIDATE,
});

export default strapiClient;
